import { InjectionToken } from '@angular/core';

import { Environment } from '../interfaces';

export const ENVIRONMENT: InjectionToken<Environment> = new InjectionToken<Environment>('APP Environments');
